import React from 'react';

import { Trans } from '@modernloop/i18n';
import { Box, Link, Typography } from '@mui/material';

import { OrgSettingsSource } from 'src/constants/routes';

import { useSyncedOrgSettingUrl } from 'src/urls/useSyncedOrgSettingUrl';

interface Props {
  source: OrgSettingsSource;
}

export const SyncedFromOrgSettings: React.FC<Props> = ({ source }) => {
  const settingsUrls = useSyncedOrgSettingUrl(source);
  const href = settingsUrls;

  const handleClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Box my={1}>
      <Typography variant="body2" color="text.secondary">
        <Trans
          i18nKey="hiring-dashboard-common:common.syncedFromOrgSettings"
          components={{ settingsLink: <Link href={href} target="_blank" onClick={handleClick} underline="hover" /> }}
        />
      </Typography>
    </Box>
  );
};
